var _circle, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHcv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#AE880D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 9,
    width: 20,
    height: 12.3333,
    fill: "url(#pattern0_116_3868)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_116_3868",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_116_3868",
    transform: "scale(0.0166667 0.027027)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_116_3868",
    width: 60,
    height: 37,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAAlCAYAAAAeJYohAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAPGSURBVHgB7ZldTttAEMdnxnZSpEpNSFupTw0naPPWBFWlJyicoHCCwgkgJwBOQDgBcAKCKiVtXzAnwDxVakngoVJR4t3prvPRtbFDUQJqLH5SpOzEdma845ndvwGmAP7eLMp281S0GxedVmMVxoBgChBZ2GGAIgDmLIR1GIOpCDgM5mAMbJhCuj8/L0Rt9q/HLs6VLm86dyoDJss+jNrkkysQrWat04HqzIuyl3gupAmE5UwWDn+rIpd0SLoC7lHMZnEv6cepTGlGuRIySFxAxI/D34Ffi1Zj0ypU1qLnIkwBfrt5qBxdGIyt2fI1v0Xryyogb4ZszGuZQmXLtKUmpa3Cmy3JvB2yIW5GK3qqnmGnUFlVU183baqi75hFLHVFC/HRkgraM0xBEeOL42DBkr6A86VL35dLqnQNFyG6iEl5FTzfaWxLkHk+77LEcIVWPdo/byymMmCN/bRcU1NbNW1E+Cm1AWusQnkDmM8GY53aqQ5Yw4inf0eYS33AUR4CTjsPAacdW+9E4D8HVTsxN3Y9n/lSSj7IPJ2vwS1A0W4yTDeekLKaFHh0a5mGlC5aRDtKz4qVbzGict5ihgeL8fFk0vFJ9oNld6nbddzBOJPBT0oUMIR7dsncVSTgSYT31mwlrz+EMMfMu3DPqJlyTT8EylJkGwhIzp4S8U4Hn3CwSgGRuI3dVmOLUN2JBDoqwJn8ddlTtht7DLgI94NH+Kikt36mUe9xma+Oe28lRqNvGM2+KZFNMxvROzW8IMiDuGA1QuA23BNCQjUarCbY+0ZknTgQeR8x+15/t/sXmvPPm8tE/MGcNWZwky7iPCvX1fNvmjyV6kcwAQjpFQetqO+w5XtJx6JEFyxjrFOf5Yn+LgFcJHSdfKU++H0o0+r9Y+fHN9eyxTBgJHqZ9EfBGz1zDPLELswvwwTQbwiVADcMmAUVk45FlEWz2fgsd6NKpUmoLTmO45lFDJkXk1R8maGP5nhUNtyWYNYMbAr/lwkRhdoRkhjpRyhgnd6qABhpibm4Vxei9XVdebVh2nyiGkwI/biENSlYUH02pD7y6XFO2yIFy3Pyb+ujrn1N0OYLlarMx9E+x335s7/My0WuUrPy5RWYILqmIMFO2MpqQtDtLSZ0Kof9UMVtJaOlnRHEvnmIU/FHENsyJsFNLdNEi/Bal77puNilpVbxWfJSUrsaoCrp0V0FqwkCiAhx8Y7I6r8Eqxn5bkmntxBq4U28rNLoXd96pgpUnQlrTl4/a3dP4IfkDexV7lcDPyTDvk+4lbRWiOMPxUmV2P/nFfEAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHcv);
export default __webpack_public_path__ + "static/media/HCV.f0fbf0b2ea1156cead5f5b2dbe643606.svg";
export { ForwardRef as ReactComponent };